export default {
    props: {

        // Whether to display the element on the bottom
        bottom: {
            type: Boolean,
            default: false
        },

        // Whether to display the element on the top
        top: {
            type: Boolean,
            default: false
        },

        // Whether to display the element on the left
        left: {
            type: Boolean,
            default: false
        },

        // Whether to display the element on the right
        right: {
            type: Boolean,
            default: false
        }
    }
}
